import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import logo from '../assets/images/SterlingLogoOnly.png';

const Header: React.FC = () => {
  return (
    <header className="py-2" style={{ backgroundColor: '#FFFDFC' }}>
      <div className="container">
        <nav className="navbar navbar-expand-lg">
          <div className="d-flex justify-content-between align-items-center w-100">
            <Link className="navbar-brand d-flex align-items-center" to="/">
              <img 
                src={logo} 
                alt="Sterling Tax Solutions" 
                height="55" 
                className="d-inline-block align-top"
              />
              <span className="ms-3 fw-bold" style={{ color: '#0D4D26', fontSize: '1.4rem' }}>
                Sterling Tax Solutions
              </span>
            </Link>
            
            <button 
              className="navbar-toggler border-0" 
              type="button" 
              data-bs-toggle="collapse" 
              data-bs-target="#navbarNav" 
              aria-controls="navbarNav" 
              aria-expanded="false" 
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
          </div>
          
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav ms-auto">
              <li className="nav-item">
                <NavLink 
                  className="nav-link px-3" 
                  to="/" 
                  end
                  style={{ color: '#0D4D26' }}
                >
                  Home
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink 
                  className="nav-link px-3" 
                  to="/services"
                  style={{ color: '#0D4D26' }}
                >
                  Services
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink 
                  className="nav-link px-3" 
                  to="/appointments"
                  style={{ color: '#0D4D26' }}
                >
                  Appointments
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink 
                  className="nav-link px-3" 
                  to="/about"
                  style={{ color: '#0D4D26' }}
                >
                  About
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink 
                  className="nav-link px-3 white-space-nowrap" 
                  to="/contact"
                  style={{ color: '#0D4D26' }}
                >
                  Contact Us
                </NavLink>
              </li>
              <li className="nav-item">
                <a 
                  href="https://www.instagram.com/sterlingtaxcanada/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="nav-link px-3"
                  style={{ color: '#0D4D26' }}
                >
                  <i className="bi bi-instagram" style={{ fontSize: '1.2rem' }}></i>
                </a>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header; 